import { AxiosResponse } from 'axios'
import { axiosClient, unauthenticatedAxiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { RightsholderContact, RightsholderContacts } from '@Entities/rightsholder/rightsholder-contact'

export const getRightsholderContacts = (rightsHolderId: number): Promise<AxiosResponse<RightsholderContacts>> =>
    axiosClient.get<RightsholderContacts>(Pathes.RightsHolder.rightsholderContacts(rightsHolderId))

export const getRightsholderContactById = (
    rightsholderId: number,
    contactId: string
): Promise<AxiosResponse<RightsholderContact>> =>
    axiosClient.get<RightsholderContact>(Pathes.RightsHolder.rightsholderContactById(rightsholderId, contactId))

export const editRightsholderContact = (contact: RightsholderContact): Promise<AxiosResponse<RightsholderContact>> =>
    axiosClient.put<RightsholderContact>(Pathes.RightsHolder.rightsholderContactById(contact.ipId, contact.id), contact)

export const createRightsholderContact = (contact: RightsholderContact): Promise<AxiosResponse<RightsholderContact>> =>
    axiosClient.post<RightsholderContact>(Pathes.RightsHolder.rightsholderContact(contact.ipId), contact)

export const deleteRightsholderContact = (rightsholderId: number, contactId: string): Promise<AxiosResponse> =>
    axiosClient.delete(Pathes.RightsHolder.rightsholderContactById(rightsholderId, contactId))

export const getPublicContacts = (ipIds: number[]): Promise<AxiosResponse<RightsholderContacts>> =>
    unauthenticatedAxiosClient.get(Pathes.Public.contacts(ipIds))
